import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/delivery-fees/Columns"
import Modal from "@/pages/delivery-fees/Model"
import { CrudProvider } from "@/context/crudContext"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"

export default function DeliveryFeeList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/pos/dashboard" },
    { label: "Delivery Fees" },
  ]

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Delivery Fees</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <DeliveryFeeTable />
      </CrudProvider>
    </>
  )
}

function DeliveryFeeTable() {
  return (
    <>
      <CustomTable
        label="Delivery Fees"
        columns={columns}
        apiPath="delivery-fee"
        view={false}
        showImport={true}
      />

      <Modal />
    </>
  )
}
